module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.modalVisible === 'duplicate-step') ? _c('layout-general', {
    on: {
      "close": function($event) {
        return _vm.modalClose()
      }
    }
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('general.actions.duplicate')) + " " + _vm._s(_vm.$t('general.labels.step')))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', [_c('h4', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t('modal.duplicate_step.are_you_sure')))])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "help-block"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('general.actions.duplicate')) + "\n        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }],
    staticClass: "klickart-select",
    staticStyle: {
      "width": "60px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.number = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")])]), _vm._v("\n        " + _vm._s(_vm.$t('general.labels.times')) + "\n      ")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.stepDuplicate(_vm.number)
      }
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v(_vm._s(_vm.$t('modal.duplicate_step.yes')))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.modalClose()
      }
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))])])])]) : _vm._e()
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-5e82ec44!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/DuplicateStep.vue
 ** module id = 841
 ** module chunks = 1
 **/